import { Injectable, Injector, TemplateRef } from '@angular/core';
import type { NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MuiBasicModal, MuiBasicModalOptions } from './mui-basic-modal.component';

@Injectable({
  providedIn: 'root'
})
export class MuiModalService {
  baseOptions: NgbModalOptions = {};

  constructor(private ngbModalService: NgbModal, private injector: Injector) {}

  open(content: any, options?: NgbModalOptions): NgbModalRef {
    return this.ngbModalService.open(content, Object.assign({
      injector: this.injector
    }, this.baseOptions, options));
  }

  openBasicModal(content: any | string | TemplateRef<any>, title?: string, options?: MuiBasicModalOptions): NgbModalRef {
    options = Object.assign(
      {
        injector: this.injector,
        // If a title is given, we can use it as the accessible label for the modal
        ariaLabelledBy: title ? 'mui-basic-modal-title' : null
      },
      this.baseOptions,
      options
    );

    const modal = this.ngbModalService.open(MuiBasicModal, options);
    const modalInstance: MuiBasicModal = modal.componentInstance;

    if (title) {
      modalInstance.title = title;
    }

    if (content instanceof TemplateRef) {
      modalInstance.content = content;
    } else if (typeof content === 'string') {
      modalInstance.message = content;
    }

    /* eslint-disable-next-line no-extra-boolean-cast */
    if (!!options) {
      if (options.ariaLabelledBy) {
        modalInstance.titleId = options.ariaLabelledBy;
      }

      if (options.showCloseButton) {
        modalInstance.closeButton = options.showCloseButton;
      }

      if (options.confirmButton) {
        modalInstance.confirmButtonConfig = Object.assign({}, modalInstance.confirmButtonConfig, options.confirmButton);
      }

      if (options.dismissButton) {
        modalInstance.dismissButton = true;
        modalInstance.dismissButtonConfig = Object.assign({}, modalInstance.dismissButtonConfig, options.dismissButton);
      }
    }

    return modal;
  }
}
